import styled from "styled-components"
export const Container = styled.section`
  background: ${({ theme }) => theme.serviceBackground};
  padding: 5rem 0;
`

export const Content = styled.section`
  width: 90vw;
  margin: 0 auto;
  max-width: 1170px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  -webkit-column-gap: 2rem;
  -moz-column-gap: 2rem;
  column-gap: 2rem;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));

  @media screen and (min-width: 992px) {
    width: 95vw;
    margin: 0 auto;
  }
`
export const Service = styled.article`
  margin-bottom: 2rem;
  border-radius: var(--radius);
  position: relative;
  transform-style: preserve-3d;
  perspective: 600px;
  width: 90%;
  max-width: 450px;
  height: 400px;
  cursor: pointer;

  @media (max-width: 900px) {
    margin: 2rem auto;
    height: 340px;
  }
`
export const Page = styled.section`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 1rem 1rem 1rem 2rem;
  backface-visibility: hidden;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.7s ease-in-out;
  background: ${({ theme }) => theme.contentBackground};
  color: ${({ theme }) => theme.fontColor};
`
export const FrontPage = styled(Page)`
  transform: rotateY(0deg) perspective(600px);

  ${Service}:hover & {
    transform: rotateY(-180deg) perspective(600px);
  }
`

export const BackPage = styled(Page)`
  transform: rotateY(180deg) perspective(600px);
  color: ${({ theme }) => theme.body};
  background: ${({ theme }) => theme.bodyColor};

  ${Service}:hover & {
    transform: rotateY(0deg) perspective(600px);
  }
`

export const Header = styled.h4`
  color: ${({ theme }) => theme.headerColor};
`
export const LanguagesContainer = styled.section`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const Tags = styled.section`
  width: 100%;
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  & span {
    margin-right: 0.4rem;
    margin-top: 0.6rem;
    padding: 3px 5px;
    border-radius: 5px;
    font-size: 0.8rem;
    text-transform: uppercase;
    background: ${({ theme }) => theme.tagBackground};
    color: ${({ theme }) => theme.tagColor};
  }
`
export const SubHeader = styled.h5`
  color: ${({ theme }) => theme.headerColor};
  font-size: 1rem;
`
export const Text = styled.p`
  color: ${({ theme }) => theme.fontColor};
  -webkit-transition: var(--transition);
  transition: var(--transition);
`

export const IconStyle = styled.section`
  border: 3px solid var(--clr-primary-5);
  border-radius: 50%;
  width: 70px;
  height: 70px;
  margin: 1rem auto 2rem;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  & svg {
    margin: 0;
    padding: 0;
  }
`
